<template lang="pug">
  .checkbox-wrap
    template(v-if="label")
      label
        .mr-checkbox(:class="{ 'selected': value } ")
          input(type="checkbox" :checked="value" @change="update($event.target.checked)" :data-mr-ass="dataMrAss" :tabindex="inputTabindex")
        | {{ label }}

    template(v-else)
      .mr-checkbox(:class="{ 'selected': value } ")
        input(type="checkbox" :checked="value" @change="update($event.target.checked)" :data-mr-ass="dataMrAss" :tabindex="inputTabindex")

</template>

<script>
  export default {
    name: "mrInputCheckbox",
    props: {
      value: {
        type: [Boolean, Number]
      },
      label: {
        type: String
      },
      inputTabindex: {
        type: String,
        required: false,
        default: "0"
      },
      dataMrAss: {
        type: String
      },
    },

    methods: {
      update(val) {
        this.$emit('input', val);
      }
    }
   }
</script>

<style scoped lang="stylus">
  .mr-checkbox
    vertical-align top
    position relative
    width 21px
    height 21px
    border 1px solid #999
    background-color color-white
    border-radius 3px
    margin-right 6px

    &:focus-within
      outline color-mr-blue auto 5px
    
    input[type="checkbox"]
      position absolute
      display block
      left 0
      right 0
      top 0
      bottom 0
      padding 0
      margin 0
      font-size 19px
      line-height 19px
      width 19px
      height 19px
      opacity 0
      
    &.selected
      &:before
        content icon-check-nobox
        font-family fontello
        text-align center
        font-size 16px
        line-height 19px
        width 19px
        height 19px
        color color-mr-purple
        position absolute
        top 0
        left 0

</style>
